// // 10-01-2026

// import React from "react";
// import { motion } from "framer-motion";
// import {
//   Phone,
//   Mail,
//   MapPin,
//   Edit,
//   Delete,
//   User,
//   IndianRupee
// } from "lucide-react";
// import "../../css/leads/leadcard.css";

// const statusColors = {
//   new: "status-new",
//   contacted: "status-contacted",
//   qualified: "status-qualified",
//   viewing_scheduled: "status-viewing",
//   negotiating: "status-negotiating",
//   closed_won: "status-won",
//   closed_lost: "status-lost"
// };

// const interestColors = {
//   cold: "interest-cold",
//   warm: "interest-warm",
//   hot: "interest-hot"
// };

// export default function LeadCard({
//   lead,
//   index,
//   selected,
//   onSelect,
//   onEdit,
//   onDelete,
//   isAdmin // 👈 NEW PROP
// }) {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ delay: index * 0.05 }}
//       className={`lead-card ${selected ? "selected" : ""}`}
//     >
//       {/* Header */}
//       <div className="lead-card-header">
//         <div className="lead-header-left">
//           <input
//             type="checkbox"
//             checked={selected}
//             onChange={onSelect}
//           />

//           <div className="avatar">
//             {lead.full_name?.charAt(0).toUpperCase()}
//           </div>

//           <div className="lead-info">
//             <h3>{lead.full_name}</h3>
//             <div className="badges">
//               <span className={`badge ${statusColors[lead.status]}`}>
//                 {(lead.status || "unknown").replace(/_/g, " ")}
//               </span>
//               <span className="badge badge-secondary">
//                 {lead.lead_type}
//               </span>
//             </div>
//           </div>
//         </div>

//         <div className="actions">
//           <button className="icon-btn" onClick={onEdit}>
//             <Edit size={16} />
//           </button>
//           {/* <button className="icon-btn" onClick={onDelete}>
//             <Delete size={16} />
//           </button> */}
//         </div>
//       </div>

//       {/* Body */}
//       <div className="lead-card-body">
//         <a href={`tel:${lead.phone}`} className="info-row">
//           <Phone size={14} />
//           {lead.phone}
//         </a>

//         {lead.email && (
//           <a href={`mailto:${lead.email}`} className="info-row">
//             <Mail size={14} />
//             {lead.email}
//           </a>
//         )}

//         {(lead.budget_min || lead.budget_max) && (
//           <div className="info-row border-top">
//             <IndianRupee size={14}/>
//             ₹{lead.budget_min || 0} - ₹{lead.budget_max || 0}
//           </div>
//         )}

//         {lead.preferred_locations?.length > 0 && (
//           <div className="info-row">
//             <MapPin size={14} />
//             {lead.preferred_locations.join(", ")}
//           </div>
//         )}

//         {/*  ADMIN ONLY: Created By Section */}
//         {/*  ADMIN ONLY: Created By Section */}
// {isAdmin && lead.createdByEmail && (
//   <div className="info-row created-by border-top">
//     <User size={14} />
//     <span>
//       Created by: <strong>{lead.createdByEmail}</strong>
//     </span>
//   </div>
// )}


//         <div className="footer">
//           <span className={`badge ${interestColors[lead.interest_level]}`}>
//             {lead.interest_level} interest
//           </span>
//           <span className="source">{lead.source}</span>
//           {/* {lead.source === "other" && lead.source_other_reason && (
//           <span className="source_other_reason">{lead.source_other_reason}</span>
//           )} */}
//         </div>
//       </div>
//     </motion.div>
//   );
// }

// 10-01-2026

import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Edit,
  Delete,
  User,
  IndianRupee,
  UserCheck,
  Building2,
  TrendingUp,
  History,
} from "lucide-react";
import ActivityLogModal from "../common/ActivityLogModal";
import "../../css/leads/leadcard.css";

const statusColors = {
  new: "status-new",
  contacted: "status-contacted",
  qualified: "status-qualified",
  viewing_scheduled: "status-viewing",
  negotiating: "status-negotiating",
  closed_won: "status-won",
  closed_lost: "status-lost"
};

const interestColors = {
  cold: "interest-cold",
  warm: "interest-warm",
  hot: "interest-hot"
};

/**
 * formatBudget — raw rupee number string → short Indian label
 * "200000" → "₹2 L" | "10000000" → "₹1 Cr" | "50000" → "₹50 K"
 */
function formatBudget(val) {
  if (!val && val !== 0) return null;
  const n = typeof val === "number" ? val : parseFloat(String(val).replace(/[^0-9.]/g, ""));
  if (isNaN(n) || n === 0) return null;
  if (n >= 10_000_000) return `₹${parseFloat((n / 10_000_000).toFixed(2))} Cr`;
  if (n >= 100_000)    return `₹${parseFloat((n / 100_000).toFixed(2))} L`;
  if (n >= 1_000)      return `₹${parseFloat((n / 1_000).toFixed(1))} K`;
  return `₹${n}`;
}

export default function LeadCard({
  lead,
  index,
  selected,
  onSelect,
  onEdit,
  onDelete,
  onAssign,
  onConvertToDeal,
  isAdmin,
}) {
  const [showLog, setShowLog] = useState(false);

  return (
    <>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className={`lead-card ${selected ? "selected" : ""}`}
    >
      {/* Header */}
      <div className="lead-card-header">
        <div className="lead-header-left">
          <input
            type="checkbox"
            checked={selected}
            onChange={onSelect}
          />

          <div className="avatar">
            {lead.full_name?.charAt(0).toUpperCase()}
          </div>

          <div className="lead-info">
            <h3><Link to={`/leads/${lead._id}`} className="lead-name-link" title="View lead details">{lead.full_name}</Link></h3>
            <div className="badges">
              <span className={`badge ${statusColors[lead.status]}`}>
                {(lead.status || "unknown").replace(/_/g, " ")}
              </span>
              <span className="badge badge-secondary">
                {lead.lead_type}
              </span>
            </div>
          </div>
        </div>

        <div className="lead-card-actions">
          {onConvertToDeal && (
            <button
              className="icon-btn convert-btn"
              title="Convert to Deal"
              onClick={onConvertToDeal}
            >
              <TrendingUp size={15} />
            </button>
          )}
          {onAssign && (
            <button
              className="icon-btn"
              title={lead.assignedToEmail ? "Reassign Lead" : "Assign Lead"}
              onClick={onAssign}
            >
              <UserCheck size={15} />
            </button>
          )}
          <button className="icon-btn" title="Activity Log" onClick={() => setShowLog(true)}>
            <History size={15} />
          </button>
          <button className="icon-btn" title="Edit" onClick={onEdit}>
            <Edit size={15} />
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="lead-card-body">
        <a href={`tel:${lead.phone}`} className="info-row">
          <Phone size={14} />
          {lead.phone}
        </a>

        {lead.email && (
          <a href={`mailto:${lead.email}`} className="info-row">
            <Mail size={14} />
            {lead.email}
          </a>
        )}

        {(lead.budget_min || lead.budget_max) && (
          <div className="info-row border-top">
            <IndianRupee size={14} />
            {formatBudget(lead.budget_min) || "—"} – {formatBudget(lead.budget_max) || "—"}
          </div>
        )}

        {lead.preferred_locations?.length > 0 && (
          <div className="info-row">
            <MapPin size={14} />
            {lead.preferred_locations.join(", ")}
          </div>
        )}

        {/* Linked property row */}
        <div className="info-row border-top">
          <Building2 size={14} />
          {lead.propertyId ? (
            <span>
              Property: <strong>{lead.propertyId?.propertyName || lead.propertyName || "Linked"}</strong>
            </span>
          ) : (
            <span className="unassigned-label">No property linked</span>
          )}
        </div>

        {/* Assigned agent row */}
        <div className="info-row">
          <UserCheck size={14} />
          {lead.assignedToEmail ? (
            <span>Assigned: <strong>{lead.assignedToEmail}</strong></span>
          ) : (
            <span className="unassigned-label">Unassigned</span>
          )}
        </div>

        {/* Admin: created by */}
        {isAdmin && lead.createdByEmail && (
          <div className="info-row created-by">
            <User size={14} />
            <span>By: <strong>{lead.createdByEmail}</strong></span>
          </div>
        )}

        <div className="footer">
          <span className={`badge ${interestColors[lead.interest_level]}`}>
            {lead.interest_level} interest
          </span>
          <span className="source">{lead.source}</span>
        </div>
      </div>
    </motion.div>

    {showLog && (
      <ActivityLogModal log={lead.activityLog || []} onClose={() => setShowLog(false)} />
    )}
    </>
  );
}